/** Stable numeric hash for deterministic illustration variants. */
export function pathHash(path: string): number {
  let h = 0;
  for (let i = 0; i < path.length; i += 1) {
    h = (Math.imul(31, h) + path.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function normalizeIllustrationPath(path: string): string {
  return path.replace(/^\//, '').replace(/\/$/, '');
}

/** Safe unique id prefix for SVG gradients (max length for DOM ids). */
export function illustrationIdPrefix(path: string): string {
  const base = normalizeIllustrationPath(path)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  const suffix = (pathHash(path) % 10000).toString(36);
  const slug = base.slice(0, 48) || 'root';
  return `ill-${slug}-${suffix}`;
}
